// removed by extract-text-webpack-plugin
module.exports = {"link":"_2xIegZLhOL6bVIyMPNp8gS","title":"_2-wPsF1TvLsXPcfHC_H47q"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DetailsLink/DetailsLink.scss
// module id = 1261
// module chunks = 1